import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from 'app/core/services/translate.service';

@Pipe({
  name: 'translateHandlebars'
})
export class TranslateHandlebarsPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(value: any, args: any): any {
    let message = this.translateService.translate(value);
    const keyList = message.match(/\{\{(.*?)\}\}/gi);
    if (!args || !keyList)
      return message;
    const keyValuePair = keyList.map(key => ({ key: key, val: this.getNestedObject(args, key.slice(2, -2).split('.')) }));
    for (let pair of keyValuePair) {
      message = message.replace(new RegExp(pair.key, 'gi'), pair.val);
    }
    return message;
  }

  private getNestedObject(nestedObj, pathArr) {
    return pathArr.reduce((obj, key) =>
      (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate-handlebars.pipe.ts